<template>
  <div>
    <article
      v-if="!isLoading"
      class="card"
    >
      <header class="text-center py-3">
        <h1
          class="text-grey-darkest text-lg1"
          v-text="title"
        />
        <CommPopper
          ref="comPopper"
          v-can="['edit-resources', 'delete-resources']"
        >
          <div
            slot="content"
            class="flex flex-col"
          >
            <a
              v-can="'edit-resources'"
              :href="editUrl"
              v-text="'Edit'"
            />
            <a
              v-if="disabled"
              v-can="'edit-resources'"
              @click.prevent="openEnableModal"
              v-text="'Enable'"
            />
            <a
              v-else
              v-can="'edit-resources'"
              @click.prevent="openDisableModal"
              v-text="'Disable'"
            />
            <a
              v-can="'delete-resources'"
              @click.prevent="openDeleteModal"
              v-text="'Delete'"
            />
          </div>
        </CommPopper>
      </header>
      <div
        v-if="image"
        class="mb-8 card-header-image"
      >
        <img
          :src="image"
          alt=""
        >
      </div>
      <div class="card-content mx-auto">
        <span v-html="content" />
      </div>
      <DeletePageModal
        :show="$store.state.resource.deletePageModal.open"
        @destroyed="redirect('resources')"
      />
      <DisablePageModal
        :show="$store.state.resource.disablePageModal.open"
        @disabled="fetchPage"
      />
      <EnablePageModal
        :show="$store.state.resource.enablePageModal.open"
        @enabled="fetchPage"
      />
      <CreateLinkModal
        :show="$store.state.resource.createLinkModalIsOpen"
        @created="redirect('resources')"
      />
    </article>
  </div>
</template>

<script type="text/babel">
import CommPopper from 'Communication/Resources/assets/js/components/CommPopper'
import EnablePageModal from './_modals/EnablePageModal'
import DisablePageModal from './_modals/DisablePageModal'
import DeletePageModal from './_modals/DeletePageModal'
import CreateLinkModal from './_modals/CreateLinkModal'

export default {
  name: 'Page',
  components: {
    CommPopper,
    CreateLinkModal,
    DeletePageModal,
    EnablePageModal,
    DisablePageModal,
  },
  props: {
    pageUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
    }
  },
  computed: {
    page() {
      return this.$store.state.resource.page
    },
    title() {
      return this.page.attributes.title
    },
    image() {
      return this.page.attributes.hero_image
    },
    content() {
      return this.page.attributes.content
    },
    disabled() {
      return this.page.attributes.disabled
    },
    editUrl() {
      return this.$urlGenerator.active(`resources/pages/${this.page.uuid}/edit`)
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetchPage()
  },
  methods:{
    fetchPage() {
      const vm = this

      this.$store.dispatch('resourceGetPage', this.pageUuid)
        .then(function () {
          vm.isLoading = false
        })
        .catch(function (error) {
          vm.$store.commit('baseAddNotification', {
            type: 'error',
            text: 'There was a problem loading this resource page.',
            timeout: false,
          })
        })
    },
    redirect(to) {
      window.location.replace(this.$urlGenerator.active(to))
    },
    hidePopper() {
      this.$refs.comPopper.close()
    },
    openDeleteModal() {
      this.$store.commit('resourceOpenDeletePageModal', this.page)

      this.hidePopper()
    },
    openDisableModal() {
      this.$store.commit('resourceOpenDisablePageModal', this.page)

      this.hidePopper()
    },
    openEnableModal() {
      this.$store.commit('resourceOpenEnablePageModal', this.page)

      this.hidePopper()
    },
  },
}
</script>
